export default __webpack_public_path__ + "static/Face2-ffbd2326abd6e7f4645497dde9f6743a.jpg";